import SVGInjector from './svg-injector';
export default SVGInjector;